import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity7 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_7;
}

export default DirtRoadTileEntity7;
